import {
	GetChannelRequest,
	GetChannelResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getChannelList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetChannels(
	payload: GetChannelRequest,
	props?: UseBaseQueryOptions<GetChannelResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetChannelList, payload],
		queryFn: () => getChannelList(payload),
		...props,
	})
}
